import {
  TextField,
  InputAdornment,
} from '@mui/material';
import { ScanIconButton } from '../../common/components';

interface ProductCodeFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  helperText?: string;
}

export default function ProductCodeField({
  label,
  value,
  onChange,
  disabled,
  helperText,
}: ProductCodeFieldProps) {
  return (
    <TextField
      fullWidth
      margin="normal"
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      helperText={helperText}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <ScanIconButton
              onDetected={(scanned) => onChange(scanned)}
              disabled={disabled}
              tooltip="Сканувати код"
            />
          </InputAdornment>
        ),
      }}
    />
  );
}
